import type { PlayerApiPayload, PlayerContent } from '@foundation-player/player-api';
import type { UIConfig } from '../foundation-ui/types/ui-config';

/**
 * Maps a PlayerApiPayload to a UiConfig
 *
 * @remarks
 * This function must be called before creating the ui to generate a UiConfig
 */
export function mapToUiConfig(playerApiPayload: PlayerApiPayload): UIConfig {
  return {
    mode: mapContentTypeToUiMode(playerApiPayload.playerContent.type),
    theme: playerApiPayload.playerUiSettings?.theme,
    headline: playerApiPayload.playerUiContent?.headline,
    secondaryHeadline: playerApiPayload.playerUiContent?.secondaryHeadline,
    poster: playerApiPayload.playerUiContent?.posterImage,
    allowNativeVideoFullscreen: playerApiPayload.playerUiSettings?.allowNativeVideoFullscreen,
    aspectRatio: playerApiPayload.playerUiSettings?.aspectRatio,
    playbackSpeedOptions: playerApiPayload.playerUiSettings?.playbackSpeedOptions,
    durationInSeconds: playerApiPayload.playerUiContent?.durationInSeconds,
  };
}

function mapContentTypeToUiMode(contentType: PlayerContent['type']): UIConfig['mode'] {
  switch (contentType) {
    case 'AUDIOBOOK':
    case 'PODCAST':
    case 'RADIO':
      return 'audio';
    case 'AD_ONLY':
    case 'EVENT':
    case 'FAST':
    case 'LIVE':
    case 'VOD':
    default:
      return 'video';
  }
}
